// extracted by mini-css-extract-plugin
export default {"container":"styles_container__uQDhX","title":"styles_title__+A6l+","desc":"styles_desc__9x+RT"};